'use client';

import { FC } from 'react';

import { ProductBadgesNode } from '@ravago/shared/page-data/models/elements';
import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { useTranslations } from '@ravago/shared/translations/client';

export const ProductSustainabilityBadgeFallback: FC<{ node: ProductBadgesNode }> = ({ node }) => {
   const translate = useTranslations();

   return (
      <Badge leadingIcon="leaf" variant={node.variantSustainability} size={node.size}>
         {translate('card-product-card-recycled')}
      </Badge>
   );
};
